import React, {useEffect} from 'react'
import template from './form-3.twig'

import parse from 'html-react-parser'

import legacyJs from './../../scripts/hubspot-form.legacy'

import {ContentOptions, HeadlineOptions, WorkshopsColors} from '@miro-site/components_utils'
import 'lazysizes'
import 'lazysizes/plugins/attrchange/ls.attrchange'

export interface Image {
  src: string
  alt: string
}

export interface Form3Props {
  background?: WorkshopsColors
  form: {
    formId: string
    headline?: HeadlineOptions
    content?: ContentOptions
    align?: 'center'
    button_description?: ContentOptions
  }
  children?: React.ReactNode
}

const Form3 = (props: Form3Props): React.ReactElement => {
  useEffect(() => {
    legacyJs.init()
  }, [])

  return (
    <>
      {parse(
        template({...props, component_name: 'Hero Section', ctf_assets: 'images.ctfassets.net'}),
      )}
    </>
  )
}

export default Form3
